import React, { useState } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Modal from '../../components/modal';

const NUMBER_OF_WARNINGS = 7;

const Container = styled.div`
  background: white;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const Title = styled.p`
  color: ${props => props.theme.primary};
  cursor: default;
  font-size: 0.7rem;
  font-weight: bold;
  margin: 1.25em 0;
  padding: 0 1em;
  transition: filter 0.25s;

  &:hover {
    filter: brightness(1.25);
  }

  @media (min-width: 375px) {
    font-size: 0.84rem;
  }

  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

const ModalTitle = styled.div`
  background: #111111;
  color: white;
  font-size: 1.1rem;
  line-height: 1.5;
  padding: 1em;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 1.3rem;
  }

  @media (min-width: 1024px) {
    margin: 1rem 1rem 0;
  }
`;

const ModalContent = styled.div`
  @media (min-width: 1024px) {
    margin: 0 1rem;
  }
`;

const Text = styled.p`
  line-height: 1.7;
`;

const List = styled.ul``;

const Announcement = () => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <Container>
      <Title onClick={() => setModalOpen(true)}>
        <Translate id="psyLandingPage.announcement.title" />
      </Title>
      {modalOpen && (
        <Modal
          onClose={() => setModalOpen(false)}
          title={
            <ModalTitle>
              <Translate id="psyLandingPage.announcement.title" />
            </ModalTitle>
          }
        >
          <ModalContent>
            <Text>
              <Translate id="psyLandingPage.announcement.text.1" />
            </Text>
            <Text>
              <Translate id="psyLandingPage.announcement.text.2" />
            </Text>
            <List>
              {new Array(NUMBER_OF_WARNINGS).fill('').map((val, index) => (
                <li key={index}>
                  <Translate
                    id={`psyLandingPage.announcement.warnings.${index + 1}`}
                  />
                </li>
              ))}
              <Translate id="psyLandingPage.announcement.text.3" />
            </List>
          </ModalContent>
        </Modal>
      )}
    </Container>
  );
};

export default Announcement;
